import {
  Box,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
  Grid,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { TextToSpeechButton, RichTextDisplay } from "@/components/common";
import PreviewAudioButton from "@/components/common/PreviewAudioButton";

export const WordItem = ({
  word,
  handleOpenWordDialog,
  handleDeleteWord,
  isAnyLoading,
}) => {
  return (
    <Grid item xs={12} sm={6} md={4} key={word.id}>
      <Card variant="outlined">
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              {word.word}
            </Typography>
            {
              word.audioUrl ? (
                <PreviewAudioButton audioUrl={word.audioUrl} />
              ) : (
                <TextToSpeechButton text={word.word} />
              )
            }
          </Box>
          {word.pronunciation && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 1, fontStyle: "italic" }}
            >
              /{word.pronunciation}/
            </Typography>
          )}
          <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
            {word.translation}
          </Typography>
          {word.explanation && <RichTextDisplay content={word.explanation} />}
          {word.example && <RichTextDisplay content={word.example} />}
          {word.imageUrl && (
            <img
              style={{ width: "100%", height: "auto" }}
              src={word.imageUrl}
              alt={word.word}
            />
          )}
        </CardContent>
        <CardActions>
          <IconButton
            color="primary"
            onClick={() => handleOpenWordDialog(word)}
            disabled={isAnyLoading}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => handleDeleteWord(word._id)}
            disabled={isAnyLoading}
          >
            <DeleteIcon />
          </IconButton>
        </CardActions>
      </Card>
    </Grid>
  );
};
